export default __webpack_public_path__ + "static/media/pw_app_desktop.963a8cee.png";